import axios from '@/axios';

const RESOURCE_NAME = '/admin/markets/corporates';

export default {
    getList(data) {
        return axios.post(`${RESOURCE_NAME}/get-list`, data)
    },

    search(query) {
        return axios.get(`${RESOURCE_NAME}/search?query=${query}`)
    },

    getData(id) {
        return axios.get(`${RESOURCE_NAME}/get-data?id=${id}`)
    },

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, data)
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-corporate?id=${id}`)
    },

    syncSubsectors(id, data) {
        return axios.post(`${RESOURCE_NAME}/sync-subsectors?id=${id}`, data)
    },
}
